import React, { useState } from "react";
import AgriDateTime from "../../../components/AgriDateTime";
import SelectBox from "../../../components/SelectBox";

function FuelForm({
  selectedCurrentDate,
  onSave,
  t,
  handChangeDate,
  handleTimeChange,
}) {
  const [selectedResponsible, setSelectedResponsible] = useState("");
  const [selectedHorimeter, setSelectedHorimeter] = useState("");
  const [selectedType, setSelectedType] = useState("Diesel");
  const [selectedQuantity, setSelectedQuantity] = useState("");

  const handleSave = (event) => {
    event.preventDefault();
    onSave({
      date: selectedCurrentDate,
      responsible: selectedResponsible,
      horimeter: selectedHorimeter,
      type: selectedType,
      quantity: selectedQuantity,
    });
  };

  return (
    <form onSubmit={handleSave}>
      <div className="container">
        <div className="row-collapse-responsive">
          <div className="col col-collapse-suply">
            <AgriDateTime
              timeLabel="Hora"
              label="Data"
              datetimeformat="true"
              selectedDate={selectedCurrentDate}
              handleDateChange={handChangeDate}
              handleTimeChange={handleTimeChange}
            />
          </div>
          <div className="col col-collapse-suply">
            <label>{t("Responsável")}</label>
            <input
              className="form-control left"
              type="text"
              value={selectedResponsible}
              onChange={(e) => setSelectedResponsible(e.target.value)}
            />
          </div>
          <div className="col col-collapse">
            <label>{t("KM/Horímetro")}</label>
            <input
              className="form-control left"
              type="number"
              value={selectedHorimeter}
              onChange={(e) => setSelectedHorimeter(e.target.value)}
            />
          </div>
          <div className="col col-collapse-suply">
            <SelectBox
              data={[
                { id: "diesel", name: "Diesel" },
                { id: "gasolina", name: "Gasolina" },
                { id: "alcool", name: "Álcool" },
              ]}
              selectedValue={selectedType}
              value="name"
              label="Combustível"
              change={(e) => setSelectedType(e.target.value)}
            />
          </div>
          <div className="col col-collapse-suply">
            <label>{t("Quantidade")}</label>
            <input
              className="form-control left"
              type="number"
              value={selectedQuantity}
              onChange={(e) => setSelectedQuantity(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div align="center">
        <input
          type="submit"
          className="btn btn-primary"
          value={t("Adicionar")}
        />
      </div>
    </form>
  );
}

export default FuelForm;
